if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.trigger = null;
        this.dialog = null;
        this.urlField = null;
        this.successMessage = null;
        this.urlToShare = '';
      }

      connectedCallback() {
        this.trigger = this.querySelector('.share-button__trigger');
        this.dialog = this.querySelector('.share-button__dialog');
        this.urlField = this.querySelector('.share-button__url-field');
        this.successMessage = this.querySelector('[id^="ShareMessage"]');
        this.urlToShare =
          this.dataset.shareUrl ||
          (this.urlField && this.urlField.value) ||
          window.location.href;

        if (this.urlField) {
          this.urlField.value = this.urlToShare;
        }

        this.trigger?.addEventListener('click', this.onTriggerClick.bind(this));

        this.dialog?.querySelector('.share-button__dialog-close')?.addEventListener('click', () => {
          this.dialog.close();
        });

        this.dialog?.addEventListener('close', () => {
          this.trigger?.setAttribute('aria-expanded', 'false');
          this.hideSuccess();
        });

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        });

        this.querySelector('[data-action="copy"]')?.addEventListener('click', this.copyToClipboard.bind(this));
      }

      onTriggerClick(event) {
        event.preventDefault();
        this.shareNativeOrOpenDialog();
      }

      async shareNativeOrOpenDialog() {
        if (navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              text: document.title,
              url: this.urlToShare,
            });
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') {
              return;
            }
          }
        }

        if (!this.dialog) {
          return;
        }

        this.syncShareTargets();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        }
        this.trigger?.setAttribute('aria-expanded', 'true');
      }

      syncShareTargets() {
        const url = this.urlToShare;
        const encUrl = encodeURIComponent(url);
        const encTitle = encodeURIComponent(document.title);
        const encText = encodeURIComponent(`${document.title} ${url}`);

        const facebook = this.querySelector('[data-share-facebook]');
        if (facebook) {
          facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`;
        }

        const twitter = this.querySelector('[data-share-x]');
        if (twitter) {
          twitter.href = `https://twitter.com/intent/tweet?url=${encUrl}&text=${encTitle}`;
        }

        const whatsapp = this.querySelector('[data-share-whatsapp]');
        if (whatsapp) {
          whatsapp.href = `https://wa.me/?text=${encText}`;
        }

        const linkedin = this.querySelector('[data-share-linkedin]');
        if (linkedin) {
          linkedin.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}`;
        }

        const email = this.querySelector('[data-share-email]');
        if (email) {
          email.href = `mailto:?subject=${encTitle}&body=${encUrl}`;
        }
      }

      hideSuccess() {
        if (!this.successMessage) {
          return;
        }
        this.successMessage.textContent = '';
        this.successMessage.classList.add('hidden');
      }

      showSuccess() {
        if (!this.successMessage || !window.accessibilityStrings) {
          return;
        }
        this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.successMessage.classList.remove('hidden');
      }

      copyToClipboard() {
        const url = this.urlToShare;

        const fallbackSelect = () => {
          if (!this.urlField) {
            return;
          }
          this.urlField.focus();
          this.urlField.select();
          this.urlField.setSelectionRange(0, url.length);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(
            () => this.showSuccess(),
            () => {
              fallbackSelect();
              this.showSuccess();
            }
          );
        } else {
          fallbackSelect();
          this.showSuccess();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.urlField) {
          this.urlField.value = url;
        }
        this.dataset.shareUrl = url;
      }
    }
  );
}
